import { cva } from 'class-variance-authority'

export const subTriggerStyles = cva(
  `
  flex
  cursor-default
  select-none
  items-center
  gap-2
  rounded-sm
  px-2
  py-1.5
  text-md
  outline-none
  focus:bg-accent
  data-[state=open]:bg-accent
  [&_svg]:pointer-events-none
  [&_svg]:size-4
  [&_svg]:shrink-0
  `,
  {
    variants: {
      inset: {
        true: 'pl-8',
      },
    },
    defaultVariants: {
      inset: false,
    },
  }
)

export const subContentStyles = cva(
  `
  z-50
  min-w-[8rem]
  overflow-hidden
  rounded-md
  border
  bg-neutral-0
  p-2
  text-neutral-600
  shadow-sm
  data-[state=open]:animate-in
  data-[state=closed]:animate-out
  data-[state=closed]:fade-out-0
  data-[state=open]:fade-in-0
  data-[state=closed]:zoom-out-95
  data-[state=open]:zoom-in-95
  data-[side=bottom]:slide-in-from-top-2
  data-[side=left]:slide-in-from-right-2
  data-[side=right]:slide-in-from-left-2
  data-[side=top]:slide-in-from-bottom-2
  origin-[--radix-dropdown-menu-content-transform-origin]
  `
)

export const contentStyles = cva(
  `
  z-50
  max-h-[var(--radix-dropdown-menu-content-available-height)]
  min-w-[8rem]
  w-full
  overflow-y-auto
  overflow-x-hidden
  rounded-md
  border-neutral-100
  border-1
  bg-neutral-0
  p-2
  text-neutral-600
  shadow-md
  data-[state=open]:animate-in
  data-[state=closed]:animate-out
  data-[state=closed]:fade-out-0
  data-[state=open]:fade-in-0
  data-[state=closed]:zoom-out-95
  data-[state=open]:zoom-in-95
  data-[side=bottom]:slide-in-from-top-2
  data-[side=left]:slide-in-from-right-2
  data-[side=right]:slide-in-from-left-2
  data-[side=top]:slide-in-from-bottom-2
  origin-[--radix-dropdown-menu-content-transform-origin]
  `
)

export const itemStyles = cva(
  `
  relative
  flex
  cursor-default
  select-none
  items-center
  gap-2
  rounded-sm
  px-2
  py-1.5
  text-md
  outline-none
  transition-colors
  cursor-pointer
  focus:bg-neutral-25
  focus:text-accent-foreground
  data-[disabled]:pointer-events-none
  data-[disabled]:opacity-50
  [&_svg]:pointer-events-none
  [&_svg]:size-4
  [&_svg]:shrink-0
  `,
  {
    variants: {
      inset: {
        true: 'pl-8',
      },
    },
    defaultVariants: {
      inset: false,
    },
  }
)

export const checkboxItemStyles = cva(
  `
  relative
  flex
  cursor-default
  select-none
  items-center
  rounded-sm
  py-1.5
  pl-8
  pr-2
  text-md
  outline-none
  transition-colors
  focus:bg-accent
  focus:text-accent-foreground
  data-[disabled]:pointer-events-none
  data-[disabled]:opacity-50
  `
)

export const radioItemStyles = cva(
  `
  relative
  flex
  cursor-default
  select-none
  items-center
  rounded-sm
  py-1.5
  pl-8
  pr-2
  text-md
  outline-none
  transition-colors
  focus:bg-accent
  focus:text-accent-foreground
  data-[disabled]:pointer-events-none
  data-[disabled]:opacity-50
  `
)

export const labelStyles = cva(
  `
    px-2
    py-1.5
    text-md
    font-bold
    text-neutral-900
  `,
  {
    variants: {
      inset: {
        true: 'pl-8',
      },
    },
    defaultVariants: {
      inset: false,
    },
  }
)

export const separatorStyles = cva(
  `
    -mx-1
    my-1
    h-px
    bg-neutral-100
  `
)

export const shortcutStyles = cva(
  `
    ml-auto
    text-sm
    tracking-widest
    opacity-60
  `
)
